<script>
  // @ts-check
  import Rule from "../../atoms/Rule.svelte";
  import SecondaryMenuLink from "./GlobalNavigationSecondaryMenuLink.svelte";

  /** Primarily used for testing @type {string} */
  export let id = undefined;

  /** @type {string}*/
  export let containerClass = "";

  /** @type {string}*/
  export let menuListClass = "";

  /** @type {import("./globalNavigationTypes").Link[]} */
  export let links;

  /** @type {import('../../utilities/themes.js').ThemeName} */
  export let theme = "lightGrey";

  /** @type {HTMLElement | undefined} */
  export let ref = undefined;
</script>

<div {id} class={containerClass}>
  <Rule type="thin" {theme} />
  <ul class="flex flex-col {menuListClass}" bind:this={ref}>
    {#each links as link (link.label)}
      <li class="group/li contents">
        <SecondaryMenuLink {link} {theme} />
      </li>
    {/each}
  </ul>
</div>
